"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _AnnotatedSuggestionRow = _interopRequireDefault(require("../KeyedAutoCompleteInput/AnnotatedSuggestionRow"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _DropdownSelector = require("./DropdownSelector.styles");

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _button = require("../../../styles/2_commonComponentStyles/button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Dropdown button for when no typing is needed for selections.
 *
 * Currently the size, shape and styling for this component will be locked down -
 *    can expand in the future by matching props from the root button component
 */
var DropdownSelector = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropdownSelector, _React$PureComponent);

  var _super = _createSuper(DropdownSelector);

  function DropdownSelector() {
    var _this;

    _classCallCheck(this, DropdownSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (id) {
      var onSelect = _this.props.onSelect;

      _this.setState({
        isOpen: false
      }, onSelect(id));
    });

    _defineProperty(_assertThisInitialized(_this), "buildOptions", (0, _memoizeOne.default)(function (options) {
      var activeId = _this.props.activeId;
      return options && options.map(function (option) {
        var optionContent = /*#__PURE__*/_react.default.createElement(_DropdownSelector.OptionButtonContent, null, /*#__PURE__*/_react.default.createElement(_DropdownSelector.OptionTitle, null, option.title), /*#__PURE__*/_react.default.createElement(_DropdownSelector.OptionContent, null, option.content));

        return /*#__PURE__*/_react.default.createElement(_AnnotatedSuggestionRow.default, {
          active: option.id + '' === activeId + '' // eslint-disable-line prefer-template
          ,
          colorTheme: "primary",
          dataTestId: "dropdown-selector-option",
          id: "dropdown-selector-option--".concat(option.id),
          key: option.id,
          onClick: function onClick() {
            _this.handleSelect(option.id);
          },
          suggestion: {
            primaryText: optionContent
          }
        });
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "buildButtonTitle", (0, _memoizeOne.default)(function (activeId) {
      var options = _this.props.options;
      var matched = options.find(function (item) {
        return item.id + '' === activeId + ''; // eslint-disable-line prefer-template
      });
      return matched && matched.title;
    }));

    return _this;
  }

  _createClass(DropdownSelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeId = _this$props.activeId,
          className = _this$props.className,
          colorTheme = _this$props.colorTheme,
          dataTestId = _this$props.dataTestId,
          disabled = _this$props.disabled,
          options = _this$props.options;
      var isOpen = this.state.isOpen;
      var renderOptions = this.buildOptions(options);
      var renderButtonTitle = this.buildButtonTitle(activeId);
      return /*#__PURE__*/_react.default.createElement(_DropdownSelector.Wrapper, null, /*#__PURE__*/_react.default.createElement(_DropdownSelector.StyledButton, {
        className: className,
        colorTheme: colorTheme,
        dataTestId: dataTestId,
        disabled: disabled,
        onClick: this.handleButtonClick
      }, renderButtonTitle, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        dataTestId: "decision-tree-button-icon",
        iconName: "chevron-down"
      })), /*#__PURE__*/_react.default.createElement(_DropdownSelector.Dropdown, {
        colorTheme: "primary",
        isOpen: isOpen
      }, renderOptions));
    }
  }]);

  return DropdownSelector;
}(_react.default.PureComponent);

_defineProperty(DropdownSelector, "propTypes", {
  /** activeId should match one of your current options and will cause the UI to indicate the given item as selected */
  activeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Used to pick the color theme to apply to the button */
  colorTheme: _propTypes.default.oneOf(_button.buttonColorThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag to disable the button, impacting visibility and click-ability */
  disabled: _propTypes.default.bool,

  /** Options array - gets shoved into the dropdown list
   *
   * `id` and `title` are required.
   * If a title is passed in as a naked string, It will be auto-styled.
   * If a component is passed in as the title, it will use the component's styling.
   *
   * `content` is optional and will be displayed as is.
   * */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string,
    iconColorTheme: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    title: _propTypes.default.string.isRequired,
    content: _propTypes2.default.children
  })).isRequired,
  // EVENTS

  /** Function to invoke upon an item being selected */
  onSelect: _propTypes.default.func.isRequired
});

_defineProperty(DropdownSelector, "defaultProps", {
  activeId: undefined,
  className: '',
  colorTheme: 'primaryLight',
  disabled: false
});

var _default = DropdownSelector;
exports.default = _default;